import { useLcaAggregatedData } from '@/stores/pathwayTemplateAnalysisStore';
import { getUnitAggregated, normalize } from '@/utils/pathwayTemplateUtils';
import LoadingSkeleton from '../core/LoadingSkeleton';
import SharedStackedBarChart from './SharedStackedBarChart/SharedStackedBarChart';

const EmissionsStackedBarChart = () => {
  const { data, loading, error } = useLcaAggregatedData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const unit = getUnitAggregated(data);
  const emissions = normalize(data?.emissions, 'category', 'amount') || [];

  return (
    <SharedStackedBarChart
      unit={unit}
      items={emissions}
      type="emissions"
      title={`Emissions by Component (${unit})`}
      emptyMessage="No emissions data available"
    />
  );
};

export default EmissionsStackedBarChart;
